import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=3f022e36&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=js&"
export * from "./step2.vue?vue&type=script&lang=js&"
import style0 from "./step2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./step2.vue?vue&type=style&index=1&id=3f022e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f022e36",
  null
  
)

export default component.exports